import React from 'react';
import { DatabaseIcon, CogIcon, LayersIcon, BarChart2Icon } from 'lucide-react';
const Slide4 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2675">
      <div className="flex flex-col space-y-6" data-id="element-2676">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-8" data-id="element-2677">How it works</h2>
        {/* Steps */}
        <div className="max-w-4xl mx-auto" data-id="element-2678">
          <div className="relative" data-id="element-2679">
            {/* Connection line */}
            <div className="absolute left-[42px] top-12 bottom-12 w-1 bg-indigo-200 hidden md:block" data-id="element-2680"></div>
            <div className="space-y-12" data-id="element-2681">
              {/* Step 1 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2682">
                <div className="flex-shrink-0 flex items-start" data-id="element-2683">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2684">
                    <DatabaseIcon className="h-8 w-8" data-id="element-2685" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2686">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2687">
                    1. Ingest & normalize catalog
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2688">
                    We connect to your product catalog through APIs or feeds,
                    then normalize and enrich the data for optimal AI
                    understanding.
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2689">
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2690">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2691"></div>
                      <span data-id="element-2692">Product data</span>
                    </div>
                    <div className="h-2" data-id="element-2693"></div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2694">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2695"></div>
                      <span data-id="element-2696">Inventory & availability</span>
                    </div>
                    <div className="h-2" data-id="element-2697"></div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2698">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2699"></div>
                      <span data-id="element-2700">Pricing & promotions</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Step 2 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2701">
                <div className="flex-shrink-0 flex items-start" data-id="element-2702">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2703">
                    <CogIcon className="h-8 w-8" data-id="element-2704" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2705">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2706">
                    2. Consultative engine → best fit
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2707">
                    Our AI engine uses consultative selling techniques to
                    understand customer needs and match them with the best
                    products.
                  </p>
                  <div className="flex flex-wrap gap-2 mb-3" data-id="element-2708">
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2709">
                      Bundles
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2710">
                      Filters
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2711">
                      Coupons
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2712">
                      Subscriptions
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2713">
                      Loyalty-aware
                    </span>
                  </div>
                </div>
              </div>
              {/* Step 3 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2714">
                <div className="flex-shrink-0 flex items-start" data-id="element-2715">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2716">
                    <LayersIcon className="h-8 w-8" data-id="element-2717" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2718">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2719">
                    3. Orchestrate channels
                  </h3>
                  <p className="text-gray-700" data-id="element-2720">
                    We deploy your AI shopping advisors across all customer
                    touchpoints, ensuring consistent experiences and seamless
                    handoffs.
                  </p>
                </div>
              </div>
              {/* Step 4 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2721">
                <div className="flex-shrink-0 flex items-start" data-id="element-2722">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2723">
                    <BarChart2Icon className="h-8 w-8" data-id="element-2724" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2725">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2726">
                    4. Measure & optimize
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2727">
                    Continuous improvement through analytics, A/B testing, and
                    learning from customer interactions.
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2728">
                    <div className="space-y-2" data-id="element-2729">
                      <div data-id="element-2730">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2731">
                          <span data-id="element-2732">Conversion Rate</span>
                          <span data-id="element-2733">+24%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2734">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '74%'
                        }} data-id="element-2735"></div>
                        </div>
                      </div>
                      <div data-id="element-2736">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2737">
                          <span data-id="element-2738">Average Order Value</span>
                          <span data-id="element-2739">+18%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2740">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '68%'
                        }} data-id="element-2741"></div>
                        </div>
                      </div>
                      <div data-id="element-2742">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2743">
                          <span data-id="element-2744">Customer Satisfaction</span>
                          <span data-id="element-2745">92%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2746">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '92%'
                        }} data-id="element-2747"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide4;